import * as yup from "yup";

// Dynamic schema generator for purchase details
export const editPurchaseDetailsSchema = (fields, orderDetails) => {
   const isCardamom = orderDetails?.commodity === "Cardamon Whole"|| orderDetails?.commodity === "Cardamom powder";
  const baseSchema = {
    nameOfTheShop: yup
      .string()
      .max(100, "Max 100 characters")
      .required("Name of Shop is required")
      .label("Name of Shop"),
    addressOfTheShop: yup
      .string()
      .max(250, "Max 250 characters")
      .required("Address of Shop is required")
      .label("Address of Shop"),
    dateOfPurchase: yup
      .date()
      .required("Date of Purchase is required")
      .label("Date of Purchase"),
    // sampleWeight: yup.string().required("Sample Weight is required").label("Sample Weight"),
    quantityOfSample: yup
      .number()
      .typeError("Quantity of Sample must be a number")
      .min(
        isCardamom ? 250 : 500,
        `Quantity of Sample must be at least ${isCardamom ? 250 : 500}`
      )
      .required("Quantity of Sample is required")
      .label("Quantity of Sample"),
    costOfSample: yup
      .number()
      .typeError("Sample Cost must be a number")
      .min(0, "Sample Cost cannot be negative")
      .required("Sample Cost is required")
      .label("Cost of Sample"),
    typeOfShop: yup
      .string()
      .required("Type of Shop is required")
      .label("Type of Shop"),
  };

  const schema = yup
    .object()
    .shape(
      Object.fromEntries(
        fields.map((field) => [
          field,
          baseSchema[field] || yup.mixed().label(field),
        ])
      )
    );

  return schema;
};
